import React from 'react';
import './index.less';

interface WarnHintProps {
  content: string | undefined;
}

const cssPreFix = 'ct-warm-hint';

const WarmHint: React.FC<WarnHintProps> = (props) => {
  const { content } = props;

  return (
    <div className={`${cssPreFix}`}>
      <div className={`${cssPreFix}-header`}>温馨提示：</div>
      <div className={`${cssPreFix}-important`}>
        充值后请先<span className={`${cssPreFix}-important2`}>【重启音箱】！</span>若仍无网络，为非活跃卡，运营商需1-2个工作日恢复（节假日顺延）。如有疑问，请您微信搜索
        <a 
          href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI3MTMxNTQwMQ==#wechat_redirect" 
          target="_blank" 
          rel="noopener noreferrer"
          className={`${cssPreFix}-link`}
        >
          【扫吧】
        </a>
        公众号联系客服或拨打客服热线：15366154807（服务时间：8:00-23:00）、400-158-1515
      </div>
      {content && (
        <>
          {content.split(/[;|；]/).map((str, index) => {
            return (
              <div className={`${cssPreFix}-tip`} key={index}>
                {index + 1}. {str}
                {index === content.split(/[;|；]/).length - 1 ? '' : '；'}
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

export default WarmHint;
